





























































































import {Prop} from "vue-property-decorator";
import {Component, Vue} from '@/shared/component';

import storeTemp from '@/stores/modules/temp';

import CrudList from '@/components/Crud/List.vue';
import TableHead from '@/components/Paginate/TableHead.vue';
import Checked from '@/components/Checked.vue';
import TableCell from '@/components/Paginate/TableCell.vue';
import {
	DxColumn,
	DxDataGrid,
	DxEditing,
	DxFilterRow,
	DxGrouping,
	DxGroupItem,
	DxGroupPanel,
	DxHeaderFilter,
	DxLookup,
	DxMasterDetail, DxPager, DxPaging,
	DxRangeRule,
	DxRequiredRule,
	DxScrolling,
	DxStringLengthRule,
	DxSummary,
	DxTotalItem, DxValueFormat
} from "devextreme-vue/data-grid";
import {DxCheckBox} from "devextreme-vue/check-box";
import {Temp, Token} from "@/models";
import {createStore} from "devextreme-aspnet-data-nojquery";
import {Stored} from "vue-stored-prop-decorator";
import storeToken from "@/stores/modules/token";
import CrudDeleteDialog from "@/components/Crud/DeleteDialog.vue";
import CrudTempEditDialog from "@/components/Crud/Temp/EditDialog.vue";
import storeTache from "@/stores/modules/tache";
import storeProjet from "@/stores/modules/projet";

@Component({
	components: {
		CrudList, TableHead, TableCell,
		DxDataGrid, DxColumn, DxEditing,
		DxFilterRow, DxHeaderFilter, DxGroupPanel,
		DxGrouping, DxScrolling, DxSummary,
		DxLookup, DxTotalItem, DxGroupItem,
		DxMasterDetail, DxStringLengthRule, DxRangeRule,
		DxRequiredRule, DxValueFormat, DxPaging,
		DxPager, DxCheckBox, Checked,
		CrudDeleteDialog, CrudTempEditDialog
	}
})
export default class CrudTempList extends Vue {

	@Prop({type: Boolean, default: true  }) private paginate;
	@Prop({type: Boolean, default: false }) private dense;
	@Stored(() => storeToken) token!: Token;

	private storeTemp = storeTemp;
	private storeTache = storeTache;
	private storeProjet = storeProjet;

	private url = process.env.VUE_APP_BACK_BASE_URL + '/api/temps'

	private editTemp: Temp = null;
	private deletedTemp: Temp = null;
	private dataGrid;

	private dataSource = createStore({
		key: 'id',
		loadUrl: `${this.url}/dxDataGrid/${this.$router.currentRoute.params.id}`,
		onBeforeSend: (method, ajaxOptions) => {
			ajaxOptions.xhrFields = { withCredentials: true };
			ajaxOptions.headers = {
				'Authorization': 'BEARER ' + this.token.id
			}
		},
	});

	public async loadTemp(data) {
		await storeTemp.dispatch('get', data.id)
		console.log(storeTemp.state.temp)
		this.editTemp = storeTemp.state.temp
	}

	public refresh() {
		this.dataGrid = this.$refs['dataGridRefKey'] as DxDataGrid
		this.dataGrid.instance.refresh()
	}

	private calculateCellValue(data) {
		let date = data.date
		if (date === null) { return }
		let year = date.substr(0,4)
		let month = date.substr(5,2)
		let day = date.substr(8,2)
		return day + '/' + month + '/' + year
	}
}
